import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
export var getTeamMemberProfileImages = function(teamMemberUserData) {
    return teamMemberUserData.image ? [
        teamMemberUserData.image
    ] : _to_consumable_array(teamMemberUserData.images).reverse().slice(0, 3);
};
